export interface Heading {
  id: string;
  text: string;
  level: number;
}

export function extractHeadings(markdown: string): Heading[] {
  return markdown
    .split('\n')
    .filter((line) => /^#{2,3}\s/.test(line))
    .map((line) => {
      const match = line.match(/^(#{2,3})\s+(.+)/);
      if (!match) return null;
      const level = match[1].length;
      const text = match[2].replace(/\*\*/g, '');
      const id = text
        .toLowerCase()
        .replace(/[^a-z0-9áéíóúñ]+/g, '-')
        .replace(/^-|-$/g, '');
      return { id, text, level };
    })
    .filter(Boolean) as Heading[];
}
